import React, { useState } from "react";
import { Plus } from "lucide-react";

export default function FAQAccordion({ items, testid = "faq-accordion" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-forest-500/15" data-testid={testid}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-forest-500/15 group/faq">
            <button
              data-testid={`faq-q-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-6 py-6 text-left group"
            >
              <span className="flex items-baseline gap-6">
                <span className="font-serif-italic text-forest-400/60 text-lg group-hover:text-forest-500 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-forest-600 text-lg md:text-xl font-medium group-hover:translate-x-1 transition-transform duration-300">
                  {item.q}
                </span>
              </span>
              <span
                className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-500 ${
                  isOpen
                    ? "bg-forest-600 border-forest-600 text-cream-100 rotate-[135deg]"
                    : "border-forest-500/20 text-forest-500 group-hover:border-forest-500/50 group-hover:bg-cream-200"
                }`}
              >
                <Plus size={14} />
              </span>
            </button>
            <div
              className={`grid transition-all duration-500 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <div className="pb-6 pl-12 pr-12 text-forest-400 leading-relaxed" data-testid={`faq-a-${i}`}>
                  {item.a}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
